import './Assets/scss/style.scss';
import { Routes, Route, useNavigate } from 'react-router-dom'
import Login from './Views/Auth/Login'
import Index from './Views/Pages/Index';
import UserData from './Views/Pages/User/User';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Anggota from './Views/Pages/Anggota/Anggota';
import Kegiatan from './Views/Pages/Kegiatan/Kegitan';
import Intruksi from './Views/Pages/Intruksi/Intruksi';
import TambahAnggota from './Views/Pages/Anggota/TambahAnggota';
import TambahKegiatan from './Views/Pages/Kegiatan/TambahKegiatan';
import TambahIntruksi from './Views/Pages/Intruksi/TambahIntruksi';
import TambahUser from './Views/Pages/User/TambahUser';
import DetailAnggota from './Views/Pages/Anggota/DetailAnggota';
import DetailKegiatan from './Views/Pages/Kegiatan/DetailKegiatan';
import DetailIntruksi from './Views/Pages/Intruksi/DetailIntruksi';

const pages = [
  { el: <Anggota />, url: 'anggota' },
  { el: <Kegiatan />, url: 'kegiatan' },
  { el: <Intruksi />, url: 'intruksi' },
  { el: <UserData />, url: 'pengguna' }
];

function App() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // const profil = useSelector(state => state.data.profil)

  useEffect(() => {
    if (!sessionStorage.token) {
      // navigate('/')
    }
  }, [])

  return (
    <>
      <Routes>
        <Route path="/loged" element={<Index />}>
          {
            pages.map(page => (
              <Route path={page.url} element={page.el} />
            ))
          }
        </Route>
        <Route path="/loged/anggota/tambah-anggota" element={<TambahAnggota />} />
        <Route path="/loged/anggota/detail/:id" element={<DetailAnggota />} />
        <Route path="/loged/kegiatan/detail/:id" element={<DetailKegiatan />} />
        <Route path="/loged/intruksi/detail/:id" element={<DetailIntruksi />} />
        <Route path="/loged/kegiatan/tambah-kegiatan" element={<TambahKegiatan />} />
        <Route path="/loged/intruksi/tambah-intruksi" element={<TambahIntruksi />} />
        <Route path="/loged/pengguna/tambah-pengguna" element={<TambahUser />} />
        <Route path="/" element={<Login />} />
      </Routes>
    </>
  );
}

export default App;
